import ReactDOM from 'react-dom';
import Button from '../button';
import { ErrorModalOverlay, ErrorModalContent } from './errorModal.styled';

const modalCopy = {
  maintenance: {
    title: 'Something unexpected has occurred',
    message: 'Please try again in a few minutes. If it continues, please reach out to customer support.',
  },
  'server-error': {
    // Covers HTTP 500 (Internal Server Error) and HTTP 415 (Unsupported Media Type).
    // 415 is not handled by the axios response interceptor (only 401/403 are)
    // nor by the useWealthlane*Api hook catch blocks (only validationErrors,
    // body.error, 401, 403 are checked). A 415 without a structured error body
    // falls through to showErrorModal().
    title: 'Something unexpected has occurred',
    message: 'Please try again in a few minutes. If it continues, please reach out to customer support.',
  },
};

interface ServerErrorModalProps {
  isRetrying: boolean;
  onDismiss: () => void;
  onRetry: () => void;
  errorType?: 'maintenance' | 'server-error';
  isNotRetryable?: boolean;
}

const ServerErrorModal = ({
  isRetrying,
  onDismiss,
  onRetry,
  errorType = 'maintenance',
  isNotRetryable = false,
}: ServerErrorModalProps): JSX.Element => {
  const { title, message } = modalCopy[errorType];

  return ReactDOM.createPortal(
    <ErrorModalOverlay id='serverErrorModalOverlay'>
      <ErrorModalContent id='serverErrorModalContent'>
        <span className='material-symbols-outlined error-icon'>error</span>
        <h5 id='serverErrorModalTitle'>{title}</h5>
        <p id='serverErrorModalMessage'>{message}</p>
        <div className='error-modal-buttons'>
          {isNotRetryable ? (
            <Button
              id='serverErrorModalOk'
              variant='primary'
              type='button'
              title='OK'
              onClick={onDismiss}
            />
          ) : (
            <>
              <Button
                id='serverErrorModalDismiss'
                variant='primary-dark'
                type='button'
                title='Dismiss'
                onClick={onDismiss}
                disabled={isRetrying}
              />
              <Button
                id='serverErrorModalRetry'
                variant='primary'
                type='button'
                title='Try Again'
                onClick={onRetry}
                loading={isRetrying}
                disabled={isRetrying}
              />
            </>
          )}
        </div>
      </ErrorModalContent>
    </ErrorModalOverlay>,
    document.body
  );
};

export default ServerErrorModal;
